// No React/API/i18n imports and no module-init effects. Batch4 must invoke capture
// before loading App/i18n, AND before passing client navigation to the router.
export const isRedirectAuth = value => typeof value === 'string' && value.length > 0 &&
  value.length <= 16384 && value.length % 32 === 0 && /^[a-f0-9]+$/i.test(value)

export function createRedirectEntry(browser, session) {
  let pending = null
  let onCleanEntry = false
  return {
    capture() {
      if (!/^\/redirect\/?$/i.test(browser.location.pathname)) {
        onCleanEntry = false
        if (pending) pending.release()
        pending = null
        return null
      }
      if (onCleanEntry && !browser.location.search && !browser.location.hash) return pending
      if (pending) pending.release()
      let auth = null
      let previousMarker = null
      let status = 'invalid'
      // Limit parsing too; never retain the original query or history state.
      try {
        if (browser.location.search.length <= 20000) {
          const values = new URLSearchParams(browser.location.search).getAll('auth')
          if (values.length === 1 && isRedirectAuth(values[0])) { auth = values[0]; status = 'ready' }
        }
      } catch (_) { status = 'invalid' }
      try { browser.history.replaceState(null, '', '/redirect') }
      catch (_) { auth = null; status = 'cleanup-failed' }
      previousMarker = session.captureEntry()
      if (session.getSnapshot().phase === 'blocked') { auth = null; status = 'blocked' }
      onCleanEntry = true
      let consumed = false
      pending = Object.freeze({
        status,
        consume() {
          if (consumed) return null
          consumed = true
          const input = { auth, previousMarker }
          auth = previousMarker = null
          return input
        },
        release() { consumed = true; auth = previousMarker = null },
      })
      return pending
    },
    dispose() { if (pending) pending.release(); pending = null },
  }
}
